import { render, staticRenderFns } from "./CalendarListHeader.vue?vue&type=template&id=06837a5a&scoped=true"
import script from "./CalendarListHeader.vue?vue&type=script&lang=ts"
export * from "./CalendarListHeader.vue?vue&type=script&lang=ts"
import style0 from "./CalendarListHeader.vue?vue&type=style&index=0&id=06837a5a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06837a5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06837a5a')) {
      api.createRecord('06837a5a', component.options)
    } else {
      api.reload('06837a5a', component.options)
    }
    module.hot.accept("./CalendarListHeader.vue?vue&type=template&id=06837a5a&scoped=true", function () {
      api.rerender('06837a5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/calendar/CalendarListHeader.vue"
export default component.exports